import Card from '../common/Card';
import SectionHeader from '../common/SectionHeader';

const teamGroups = [
  {
    title: 'Management',
    members: [
      {
        initials: 'SS',
        image: '/team/ceo_cto.png',
        name: 'Satyam Sir',
        role: 'Founder & CEO',
        description:
          'Founder & CEO, Factor Street E-commerce Services Pvt. Ltd. Leading technology products, education platforms, and business systems.',
      },
      {
        initials: 'RP',
        image: '/team/cofounder.png',
        name: 'Rajesh Purbey',
        role: 'Cofounder',
        description:
          'Cofounder supporting business planning, operations, and long-term company initiatives.',
      },
    ],
  },
  {
    title: 'Tech Team',
    members: [
      {
        initials: 'SS',
        image: '/team/ceo_cto.png',
        name: 'Satyam Sir',
        role: 'CTO',
        description:
          'Guides product architecture, full-stack systems, and technical execution across FactorStreet projects.',
      },
      {
        initials: 'FS',
        name: 'Coming Soon',
        role: 'Full Stack Web Developer',
        status: 'Hiring',
        description:
          'Upcoming technical role for product development, backend systems, frontend interfaces, and deployment workflows.',
      },
    ],
  },
  {
    title: 'Teachers & Content Creator',
    members: [
      {
        initials: 'SS',
        image: '/team/ceo_cto.png',
        name: 'Satyam Sir',
        role: 'Physics',
        description:
          'Physics teaching, mentoring, concept development, and learning system direction.',
      },
      {
        initials: 'SS',
        image: '/team/chem.png',
        name: 'Sachin Sir',
        role: 'Chemistry',
        description:
          'Chemistry faculty support for educational content and student-focused learning initiatives.',
      },
      {
        initials: 'NS',
        image: '/team/math.png',
        name: 'Nithin Sir',
        role: 'Mathematics',
        description:
          'Mathematics faculty support for structured learning content and academic resources.',
      },
      {
        initials: 'AR',
        image: '/team/content.png',
        name: 'Akshit Rangbulla',
        role: 'Content',
        description:
          'Content support for educational materials, learning assets, and structured resource development.',
      },
    ],
  },
  {
    title: 'HR & Accounts',
    members: [
      {
        initials: 'HR',
        image: '/team/hr.png',
        name: 'Shradha Mam',
        role: 'HR',
        description:
          'HR coordination, hiring support, candidate communication, and team process management.',
      },
      {
        initials: 'AC',
        image: '/team/account.png',
        name: 'Gyan Associate',
        role: 'Accounts',
        description:
          'Accounts and operational support for finance records, coordination, and internal business processes.',
      },
    ],
  },
  {
    title: 'Sales & Marketing',
    members: [
      {
        initials: 'BD',
        name: 'Coming Soon',
        role: 'Business Development Executive',
        status: 'Hiring',
        description:
          'Upcoming sales and marketing role for business development, client communication, outreach, and growth support.',
      },
      {
        initials: 'SM',
        name: 'Coming Soon',
        role: 'Sales & Marketing Executive',
        status: 'Hiring',
        description:
          'Upcoming sales and marketing role for campaign coordination, lead support, brand outreach, and customer communication.',
      },
    ],
  },
];

function TeamAvatar({ image, initials, name }) {
  return (
    <span className="team-card__avatar-wrap">
      {image ? (
        <img
          className="team-card__image"
          src={image}
          alt={name}
          onError={(event) => {
            event.currentTarget.hidden = true;
            event.currentTarget.nextElementSibling.hidden = false;
          }}
        />
      ) : null}
      <span className="avatar-placeholder" hidden={Boolean(image)}>
        {initials}
      </span>
    </span>
  );
}

function TeamSection() {
  return (
    <section className="section team-section">
      <div className="container">
        <SectionHeader
          eyebrow="Team"
          title="Meet our team"
          description="A growing team working across technology, education, operations, and business development."
        />

        <div className="team-category-list">
          {teamGroups.map((group) => (
            <section className="team-category" key={group.title}>
              <h3>{group.title}</h3>
              <div className="team-grid">
                {group.members.map((member) => (
                  <Card className="team-card" key={`${group.title}-${member.role}-${member.name}`}>
                    <TeamAvatar
                      image={member.image}
                      initials={member.initials}
                      name={member.name}
                    />
                    <div className="team-card__content">
                      <div className="team-card__meta">
                        <p className="team-card__label">{member.role}</p>
                        {member.status ? (
                          <span className="team-card__badge">{member.status}</span>
                        ) : null}
                      </div>
                      <h4>{member.name}</h4>
                      <p>{member.description}</p>
                    </div>
                  </Card>
                ))}
              </div>
            </section>
          ))}
        </div>
      </div>
    </section>
  );
}

export default TeamSection;
